// Hook: POST /company/locations - dodaj lokacje

import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError, ICommandResponseSuccess } from 'api/types';

export interface IRequest {
  name: string;
  city: string;
  address: string;
  postal_code: string;
  country: string;
  phone?: string | null;
  is_headquarters?: boolean;
}

type IResponse = ICommandResponseSuccess;

const postCompanyLocation = (data: IRequest): Promise<IResponse> =>
  axios.post('/company/locations', data);

export const usePostCompanyLocation = (
  options?: UseMutationOptions<IResponse, IError, IRequest>
) => useMutation((data: IRequest) => postCompanyLocation(data), options);
